var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.647 0L29.0499 8.60457V21.7741C29.0499 23.7141 27.4714 25.2926 25.5314 25.2926H3.76264C1.82259 25.2926 0.244068 23.7141 0.244068 21.7741V8.60457L14.647 0ZM3.94513 9.06711L14.507 15.6528L14.5617 15.6823C14.5705 15.6869 14.5789 15.6911 14.5908 15.6957L14.6034 15.6987C14.6332 15.706 14.647 15.7064 14.6474 15.7064C14.6474 15.7064 14.6615 15.706 14.6986 15.6972L14.7051 15.6957C14.7147 15.6918 14.725 15.6869 14.7388 15.68C14.7537 15.6716 14.769 15.6631 14.7843 15.6551L25.3485 9.06711L14.647 2.67384L3.94513 9.06711ZM3.76264 22.9976H25.5314C26.2058 22.9976 26.7545 22.4489 26.7545 21.7748V10.8955L15.97 17.62C15.9305 17.6449 15.8908 17.6671 15.8491 17.6885C15.8265 17.7008 15.8043 17.7126 15.7833 17.7229C15.6157 17.8094 15.4451 17.8752 15.284 17.9173L15.1952 17.9383C15.0093 17.9804 14.8253 18.0018 14.6458 18.0018C14.4676 18.0018 14.2824 17.98 14.0953 17.9372L14.0188 17.9196C13.8493 17.8756 13.6783 17.8094 13.5142 17.7245C13.4905 17.7126 13.4671 17.7004 13.4426 17.687L2.53954 10.8943V21.7741C2.53954 22.4489 3.08816 22.9976 3.76264 22.9976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.90b09f5470b35f672ef7641284b570d0.svg";
export { ForwardRef as ReactComponent };